import React from "react";
import "./Header.css";
import smallWhiteLogo from "./images/logo-chart-only-white.png";

const Header = () => (
  <header className="header-bg">
    <div className="mw9 center pa4 pt5-ns ph6-l">
      <span className="f6 mb2 dib ttu tracked">
        <small>
          <a
            href="https://www.o3powered.com/?ref=churncalculator"
            className="white no-underline"
          >
            <span style={{ verticalAlign: "middle" }}>Presented by </span>
            <img
              src={smallWhiteLogo}
              alt="O3"
              style={{ width: "2.7rem", verticalAlign: "middle" }}
            />
          </a>
        </small>
      </span>
      <h3 className="f1 f-subheadline-l measure-narrow lh-title mv0">
        <span className="lh-copy pl-gold pa1 tracked-tight">
          Churn Rate Calculator
        </span>
      </h3>
      <h4 className="f3 fw1 i mv0 mv3-ns">
        Improve your customer retention and profit!
      </h4>
    </div>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js